import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VibApiResponse } from '../bo/vib-api-response';
import { Ponderation } from '../bo/ponderation.model';

@Injectable({
  providedIn: 'root'
})
export class PonderationService {
  private readonly baseUrl = environment.vibrationApiURL + '/api';

  constructor(private readonly httpClient: HttpClient) {}

  getAllPonderations(): Observable<VibApiResponse<Ponderation[]>> {
    return this.httpClient.get<VibApiResponse<Ponderation[]>>(`${this.baseUrl}/ponderation/all`);
  }
}
